import { render, staticRenderFns } from "./CartaoRecorrencia.vue?vue&type=template&id=19955df3&scoped=true"
import script from "./CartaoRecorrencia.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoRecorrencia.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoRecorrencia.vue?vue&type=style&index=0&id=19955df3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19955df3",
  null
  
)

export default component.exports